import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faInstagram, faTwitter, faLine } from '@fortawesome/free-brands-svg-icons'
import FontAwesomeIcon from './Main.vue'

library.add(fas, far, faFacebook, faTwitter, faInstagram, faLine)

export default FontAwesomeIcon
